import {
  Chip, IconButton, MenuItem, TextField,
} from '@mui/material';
import { OpenInNew as OpenInNewIcon } from '@mui/icons-material';
import { Box, Stack } from '@mui/system';
import React from 'react';
import { Addon } from '../features/addons/addons';

export const AddonsMultiSelect = ({
  addonsState,
  value,
  onChange,
}: {
  addonsState: Addon[];
  value: string[];
  onChange: (ids: string[]) => void;
}) => (
  <TextField
    select
    SelectProps={{
      multiple: true,
      value,
      onChange: (e) => {
        const next = Array.isArray(e.target.value) ? e.target.value.map(String) : [];
        onChange(next);
      },
      renderValue: (selected) => (selected as string[]).join(', '),
    }}
    label="Addons"
    helperText="Select addons this coupon applies to"
    fullWidth
  >
    {addonsState.map((opt) => (
      <MenuItem key={opt.id} value={opt.id}>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ width: '100%' }}>
          <Box sx={{ flexGrow: 1 }}>{opt.name}</Box>
          <Chip
            size="small"
            color={opt.kind === 'recurring' ? 'primary' : 'default'}
            label={opt.kind === 'recurring' ? 'recurring' : 'one-time'}
          />
          <Chip size="small" label={opt.id} />
          {opt.chargebee_url && (
            <IconButton
              size="small"
              aria-label={`open ${opt.id} in Chargebee`}
              title="Open in Chargebee"
              href={opt.chargebee_url}
              target="_blank"
              rel="noopener noreferrer"
              component="a"
              /* Stop click from toggling the MenuItem selection. */
              /* eslint-disable-next-line react/jsx-no-bind */
              onClick={(e: React.MouseEvent) => e.stopPropagation()}
            >
              <OpenInNewIcon fontSize="small" />
            </IconButton>
          )}
        </Stack>
      </MenuItem>
    ))}
  </TextField>
);
